<script setup>
defineProps({
    index: {
        type: Number,
        required: true
    },
    pagination: {
        type: Object,
        required: true,
        validator: (value) => {
            return value.current && value.pageSize;
        }
    }
});

const calculateIndex = (index, pagination) => {
    const { current, pageSize } = pagination;
    if (
        !current ||
        !pageSize ||
        typeof current !== 'number' ||
        typeof pageSize !== 'number'
    ) {
        console.warn('Invalid pagination values:', { current, pageSize });
        return index + 1;
    }
    return (current - 1) * pageSize + index + 1;
};
</script>

<template>
    <span>{{ calculateIndex(index, pagination) }}</span>
</template>
